import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { withTranslation } from 'react-i18next'

import ClearFiltersButton from './ClearFiltersButton'
import StoresList from './StoresList'
import { BlueBox as BlueBoxComponent, DateSelector } from '../common'
import { Padding } from '../../../..'
import Tooltip, { Tiptext } from '../../../../Tooltip'
import { colors } from '../../../../../constants'
import { mediaQueryForBigger, withSize } from '../../../../utils'

const BlueBox = styled(BlueBoxComponent)`
    overflow: visible;
`

const FlexBox = styled.div`
    ${mediaQueryForBigger.mobile(`
    display: flex;
    justify-content: space-between;
  `)}
`

const HeaderLabel = styled.span`
    color: ${colors.greylighter};
    text-transform: uppercase;
`

const HeaderButton = styled.a`
    cursor: pointer;
    font-weight: bold;

    ${mediaQueryForBigger.mobile(`
    padding: 15px;
  `)}
`

const StoreFilter = styled(Tooltip)`
    text-transform: capitalize;
`

const Header = ({
    isClearFiltersVisible,
    labelsDateFilter,
    onChangeDateFilter,
    onClearFilters,
    onStoreChange,
    onStoreInputChange,
    selectedDateFilter,
    selectedStore,
    stores,
    storeInputValue,
    valuesDateFilter,
    t,
    isMobile,
}) => (
    <BlueBox noFooter>
        <Padding fullHeight>
            <FlexBox>
                <div>
                    <HeaderLabel>{t('store')}</HeaderLabel>
                    <HeaderButton>
                        <StoreFilter>
                            {!isMobile && selectedStore}
                            <Tiptext position={isMobile ? 'mobile' : 'right'}>
                                <StoresList
                                    stores={stores}
                                    storeInputValue={storeInputValue}
                                    onStoreChange={onStoreChange}
                                    onStoreInputChange={onStoreInputChange}
                                />
                            </Tiptext>
                        </StoreFilter>
                    </HeaderButton>
                </div>
                <div>
                    <DateSelector labels={labelsDateFilter} onChange={onChangeDateFilter} selected={selectedDateFilter} values={valuesDateFilter} />
                    <ClearFiltersButton onClick={onClearFilters} show={isClearFiltersVisible} />
                </div>
            </FlexBox>
        </Padding>
    </BlueBox>
)

Header.propTypes = {
    isClearFiltersVisible: PropTypes.bool,
    labelsDateFilter: PropTypes.arrayOf(PropTypes.string),
    onChangeDateFilter: PropTypes.func,
    onClearFilters: PropTypes.func,
    onStoreChange: PropTypes.func,
    onStoreInputChange: PropTypes.func,
    selectedDateFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    selectedStore: PropTypes.string,
    stores: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            value: PropTypes.string,
        })
    ),
    storeInputValue: PropTypes.string,
    valuesDateFilter: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    t: PropTypes.func.isRequired,
    isMobile: PropTypes.bool,
}

Header.defaultProps = {
    isClearFiltersVisible: false,
    labelsDateFilter: [],
    onChangeDateFilter: () => null,
    onClearFilters: () => null,
    onStoreChange: () => null,
    onStoreInputChange: () => null,
    selectedDateFilter: null,
    selectedStore: null,
    stores: [],
    storeInputValue: '',
    valuesDateFilter: [],
    isMobile: false,
}

export default withSize(withTranslation()(Header))
